import { Menu, MenuItem } from "@mui/material";
import { Pages } from "../../utils";
import { HashLink } from "react-router-hash-link";

const designerDropdownLinks = [
  {
    label: "The HDG Advantage",
    to: Pages.JOIN_AS_DESIGNER,
  },
  {
    label: "Our Homeowners",
    to: Pages.HOMEOWNER_LANDING,
  },
  {
    label: "Our Design Community",
    to: Pages.DESIGN_COMMUNITY,
  },
  {
    label: "Your Business Streamlined",
    to: Pages.ABOUT_DESIGN_HUB,
  },
  {
    label: "Get Paid Like a Pro",
    to: `${Pages.ABOUT_DESIGN_HUB}#get-paid`,
  },
  {
    label: "Territories & Marketing",
    to: `${Pages.TERRITORIES}`,
  },
  {
    label: "Events",
    to: Pages.EVENTS,
  },
  {
    label: "Pricing",
    to: Pages.DESIGNER_MEMBERSHIP_PRICING,
  },
  {
    label: "Personality Quiz",
    to: Pages.DESIGNER_PERSONALITY_QUIZ,
  },
];

export const DesignerNavMenu = ({
  anchor,
  onClose,
}: {
  anchor: HTMLElement | null;
  onClose: () => void;
}) => {
  return (
    <Menu
      anchorEl={anchor}
      open={Boolean(anchor)}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          width: {
            xs: "100vw",
            sm: "auto",
          },
        },
      }}
      keepMounted
    >
      {designerDropdownLinks.map((link) => (
        <MenuItem
          onClick={onClose}
          key={link.label}
          component={HashLink}
          to={link.to}
        >
          {link.label}
        </MenuItem>
      ))}
    </Menu>
  );
};
